import { LandingSvg, landingImages } from 'assets';

export const dataCollectionFeatures = [
    {
        id: 'real-time-data',
        title: 'Real‑Time Data Tracking (Web + Mobile + Offline)',
        text: 'Capture every data point in the moment - without delays or refreshing. TherapyLake syncs instantly across devices and ' +
            'users, and it keeps working even when Wi‑Fi doesn’t. Collect offline and everything securely syncs as soon as you’re back online',
        bullets: [
            'Track key ABA data types (frequency, duration, interval, task analysis, and more)',
            'Auto‑sync across devices and team members in real time',
            'Offline collection with secure sync when reconnected',
            'Built for clinic, home, tele-visits and school sessions',
        ],
        BadgeIcon: LandingSvg.ZapSvg,
        badgeLabel: 'Make it simple',
        imageSmall: landingImages.realTimeImgSmall,
        image:  landingImages.realTimeImg,
    },
    {
        id: 'custom-programs',
        title: 'Custom Programs, Targets & Templates',
        text: 'Build programs that match your clinical style - then reuse them across clients and teams. TherapyLake helps you standardize what should be consistent, while keeping the flexibility clinicians need to individualize care',
        bullets: [
            'Create and reuse goal/program templates across your organization',
            'Configure prompts, phases, and mastery criteria to match your approach',
            'Copy, adjust, and individualize programs in seconds (without rebuilding)',
            'Share programming across clinicians and clients',
        ],
        BadgeIcon: LandingSvg.FirstlineSvg,
        badgeLabel: 'Personalize your sessions',
        imageSmall: landingImages.customProgramsImgSmall,
        image:  landingImages.customProgramsImg,
    },
    {
        id: 'integrated-session-notes',
        title: 'Integrated Session Notes & Signatures',
        text: 'Reduce end‑of‑day paperwork by documenting while you collect. TherapyLake keeps session data and notes connected, so documentation stays accurate, complete, and ready when you need it',
        bullets: [
            'Collect data and complete session notes side‑by‑side',
            'Customizable note templates to match funder or internal requirements',
            'Capture one or multiple signatures directly from mobile',
            'Optional session metadata support (e.g., time/location capture where needed)',
        ],
        BadgeIcon: LandingSvg.Note2Svg,
        badgeLabel: 'DOCUMENT AS YOU GO',
        imageSmall: landingImages.integratedSessionImgSmall,
        image:  landingImages.integratedSessionImg,
    },
    {
        id: 'automated-graphing',
        title: 'Automated Graphing & Progress Visibility',
        text: 'Turn raw session data into clear, actionable progress views—automatically. See trends sooner, course‑correct faster, and make reviews easier for clinicians and leadership',
        bullets: [
            'Automatically visualize progress as data is collected',
            'Review performance by client, program/target, and time range',
            'Add clinical context to progress (e.g., phase changes / key events where applicable)',
            'Export charts and datasets when it’s time to share or report',
        ],
        BadgeIcon: LandingSvg.BarChart2Svg,
        badgeLabel: 'INSTANT INSIGHTS',
        imageSmall: landingImages.automatedGraphingImgSmall,
        image:  landingImages.automatedGraphingImg,
    },
    {
        id: 'one-system',
        title: 'One Login. One System. No “Stitched‑Together” Workflows.',
        text: 'TherapyLake Data Collection is built into the platform—not bolted on. That means one login and a single source of truth across your clinical and operational workflows, without jumping between separate tools',
        bullets: [
            'One login for data collection and practice management',
            'Sessions connect cleanly to scheduling and client records (no duplicate entry)',
            'Reduce mismatches between appointments, documentation, and what actually happened',
            'A unified record that stays consistent across teams and locations',
        ],
        BadgeIcon: LandingSvg.Square3Svg,
        badgeLabel: 'TRULY ALL‑IN‑ONE',
        imageSmall: landingImages.oneLoginImgSmall,
        image:  landingImages.oneLoginImg,
    },
    {
        id: 'hipaa-ready',
        title: 'HIPAA‑Ready Security & Access Controls',
        text: 'Data collection is only valuable if it’s protected. TherapyLake is built with security controls that support HIPAA‑aligned operations and help organizations manage access confidently',
        bullets: [
            'Encryption in transit and at rest',
            'Role‑based access control to limit who can see what',
            'Audit logs for accountability and compliance support',
            'Secure backups to protect against data loss',
        ],
        BadgeIcon: LandingSvg.SecuritySafeSvg,
        badgeLabel: 'SECURE BY DESIGN',
        imageSmall: landingImages.readySecurityImgSmall,
        image:  landingImages.readySecurityImg,
    },
];
